export default {
  utms: {
    utm_medium: {
      days: 30,
    },
    utm_source: {
      days: 30,
    },
    utm_campaign: {
      days: 30,
    },
    utm_content: {
      days: 30,
    },
    utm_term: {
      days: 30,
    },
  },
  other: {
    gf_ad_set_id: {
      days: 30,
    },
    gf_ad_id: {
      days: 30,
    },
    admitad_uid: {
      days: 90,
    },
    autocoupon: {
      days: 1,
    },
    // autocoupon discount
    aud: {
      days: 1,
    },
    audt: {
      days: 1,
    },
    invite: {
      days: 1,
    },
    // trial price
    tp: {
      days: 30,
    },
    // show trial promo
    stp: {
      days: 30,
    },
    ffb: {
      days: 30,
    },
    document_referrer: { days: 30 }, // это фейк для реактивизации куки
    fdp: { days: 5 }, // force disable promo
    cmz: { days: 1 }, // actually ignored
    fdc: { days: 5 }, // force disable customization
  },
}
